module.exports = __webpack_public_path__ + "img/padButtonView.96ce96b0.png";